/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import Axios from 'axios';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { verifyemail } from 'shared/settings/apiconfig';

// style imports
import './VerifyEmail.scss';

/**
 * this page is used to verify new email
 * 
 * @param token
 * 
 * @returns html code to display invalid or expired token message
 * 
**/

export class VerifyEmail extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pageLoading: true,
        };
    }

    componentDidMount() {
        this.validateToken();
    }

    /* checks whether the token is valid */
    validateToken = async () => {
        const token = this.props.location.search;
        if (token.includes('?token=')) {
            this.setState({
                token: token.replace('?token=', '')
            });

            await Axios.get(getSellerUrl(`${verifyemail}/${token.replace('?token=', '')}`), getSellerHeaders(false))
                .then(response => {
                    this.setState({ pageLoading: false });
                    // toast.success(response.data['message']);
                    this.props.history.push({ pathname: '/', state: { message: response.data['message'], type: 'success' } });
                })
                .catch(error => {
                    this.setState({ pageLoading: false });
                    // toast.error(error.response.data['message']);
                });
        } else {
            this.props.history.push('/');
        }
    };

    render() {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center bg-primary email-verify">
                {
                    this.state.pageLoading ?
                        <Spinner animation="border" variant="info" className="spinner-3x" /> :
                        <div className="d-flex flex-column bg-white p-4 email-verify-card">
                            <div className="d-flex flex-row justify-content-center mb-4">
                                <img src={`${process.env.PUBLIC_URL}/static/logo/Seller_webapp_Icon1.png`} alt="logo" height="50px" width="170px" />
                            </div>

                            <div className="d-flex flex-row mt-5">
                                <h5 className="text-secondary"><b>Email Verify</b></h5>
                            </div>
                            <div className="d-flex flex-column my-5">
                                <p>The link you provided to verify email is either invalid or expired.</p>
                                <div className="d-flex flex-row justify-content-end">
                                    <Link to="/">
                                        <small className="text-secondary">Back To Sign In</small>
                                    </Link>
                                </div>
                            </div>
                        </div>
                }
            </div>
        );
    }
}